import Loader from '@/components/feedback/loader';
import styles from './loading-screen.module.scss';

export const FullScreenLoading = () => (
  <div className={styles[`loading-screen__page`]}>
    <Loader className={styles[`loading-screen__loader`]} />
  </div>
);
